import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDgi7wAfBSf7mwhv9XlAY3FfETm0L2L_TY",
  authDomain: "gt-routes.firebaseapp.com",
  databaseURL: "https://gt-routes.firebaseio.com",
  projectId: "gt-routes",
  storageBucket: "gt-routes.appspot.com",
  messagingSenderId: "1093256247426",
  appId: "1:1093256247426:web:1a6ca159793b3e2806dc9b",
  measurementId: "G-5SW3GKXYMK",
};

firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();

// collection references
const routesCollection = db.collection("routes");
const routesStorage = storage.ref().child("routes");

// export utils/refs
export { db, auth, routesCollection, routesStorage };



// WEBPACK FOOTER //
// ./src/constants/gt-routes-firebase.js